import { __assign, __read, __values } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import MoaStyledComponent from '../../Style/MoaStyled';
import { DropList } from '../../';
var StyledComponent = function (props) {
    var languages = props.languages, dropListProps = props.dropListProps, storybook = props.storybook;
    var _a = __read(useState(new Map()), 2), data = _a[0], setData = _a[1]; // value, { itemName, path }
    var _b = __read(useState([]), 2), items = _b[0], setItems = _b[1]; // [ itemName, path ]
    var _c = __read(useState(undefined), 2), value = _c[0], setValue = _c[1];
    useEffect(function () {
        if (languages !== undefined) {
            setData(new Map(languages.map(function (language, index) {
                return [index + 1, language]; // 1부터 시작
            })));
        }
        else {
            setData(new Map([
                [1, { name: 'Korean', path: 'ko' }],
                [2, { name: 'English', path: 'en' }],
                [3, { name: 'Japanese', path: 'ja' }],
            ]));
        }
    }, [languages]);
    useEffect(function () {
        var e_1, _a;
        if (data.size === 0)
            return;
        setItems(Array.from(data.keys()).map(function (key) {
            var _a;
            return [(_a = data.get(key)) === null || _a === void 0 ? void 0 : _a.name, key];
        }));
        var curPathName = window.location.pathname;
        try {
            for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                var _b = __read(data_1_1.value, 2), key = _b[0], value_1 = _b[1];
                if (value_1.path === curPathName) {
                    setValue(key);
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }, [data]);
    useEffect(function () {
        if (items.length > 0 && items[0][1] !== undefined) {
            setValue(items[0][1]); // default value
        }
    }, [items]);
    var onChangeHandler = useCallback(function (e) {
        var _a, _b, _c;
        var curValue = e.target.value;
        setValue(curValue);
        if (storybook) {
            //storybook에서는 경고창만 띄워준다.
            alert("Add to '/".concat((_a = data.get(curValue)) === null || _a === void 0 ? void 0 : _a.path, "' in urlPath"));
        }
        else {
            //url path 변경 동작
            if (data.get(curValue) && ((_b = data.get(curValue)) === null || _b === void 0 ? void 0 : _b.path)) {
                window.location.pathname = '/' + ((_c = data.get(curValue)) === null || _c === void 0 ? void 0 : _c.path);
            }
        }
    }, [data, storybook]);
    return (_jsx(DropList, __assign({ itemList: items, defaultValue: 'NONE', value: value, onChange: onChangeHandler, width: '100px' }, dropListProps)));
};
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
